import {
  useLineSettingsQuery,
  useThreadsQuery,
} from '@/features/internal/patient-messaging'

// サイドバーの「やり取り」(LINE) の状態。IconBar (出すか・未読ドット) と一覧ペインが同じ取得を読む。
// LINE 連携の設定が済んでいない店舗では一覧を取りに行かない (項目ごと出さない)。
export const useLineInbox = () => {
  const { data: settings } = useLineSettingsQuery()
  const isConfigured = settings?.is_configured ?? false
  const { data, isLoading } = useThreadsQuery(isConfigured)
  const threads = data?.results ?? []
  return {
    isConfigured,
    threads,
    isLoading,
    // back は先頭の 1 ページしか返さない。溢れたことは一覧の終端で言う (黙って切らない)
    hasMore: !!data?.next,
    hasUnread: threads.some((t) => t.unread_count > 0),
  }
}
